import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { loadRecommendationsForRoutes } from '@common/redux/slices/recommendation.slice';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { SingleRoute } from "@kursk/components/pages/SingleRoute/SingleRoute";
import { loadArticle } from "@common/redux/slices/articles.slice";
import { articlePageProps } from "@kursk/utils/entitiesPages";

export default function page({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return <SingleRoute /> ;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params, req, }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadArticle({ _id: id })),
    store.dispatch<any>(loadRecommendationsForRoutes({ _id: id })),
  ]);
  const { article } = store.getState().articleList;
  return articlePageProps(article, req, false, 'routes');
});
